<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Packs list</h4>
                            
                        </div>
                        <router-link v-if="perms.includes('create-packs')" to="/create-pack" class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Add a pack</router-link>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="d-flex justify-content-end mb-3">
                        <input v-model="tableSearch" type="search" class="form-control" style="max-width: 360px;" placeholder="Search packs" aria-label="Search packs">
                    </div>
                    <div class="table-responsive rounded mb-3">
                    <table id="example" class="data-table table mb-0 tbl-server-info">
                        <thead class="bg-white text-uppercase">
                            <tr class="ligth ligth-data">
                                <th>Title</th>
                                <th>Amount</th>
                                <th v-if="perms.includes('edit-packs') || perms.includes('delete-packs')">Actions</th>
                            </tr>
                        </thead>
                        <tbody class="ligth-body">
                            <tr v-for="(pack,index) in filteredPacks" :key="index">
                                <td>{{pack.libelle}}</td>
                                <td>{{pack.amount}}</td> 
                                <td v-if="perms.includes('edit-packs') || perms.includes('delete-packs')">
                                    <div class="d-flex align-items-center list-action">
                                        
                                        <router-link :to="'/show-pack/'+pack.id" v-if="perms.includes('edit-packs')"
                                                    class="badge badge-info mr-2" data-toggle="tooltip" data-placement="top" 
                                                    title="" data-original-title="View"><i class="fa fa-eye mr-0"></i>
                                        </router-link>
                                        
                                        <button v-if="perms.includes('delete-packs')" class="btn bg-warning mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="destroy(pack.id)"><i class="fa fa-trash mr-0"></i></button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
            <!-- Page end  -->
        </div>
        <!-- Modal Edit -->
        <div class="vld-parent">
                <loading v-model:active="isLoading"
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            </div>
    </div>
</template>
<script>
import axios from "axios";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/css/index.css';
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data() {
        return {
            perms: [],
            packs:{},
            tableSearch: '',
            isLoading: false,
            fullPage: true,
        };
    },
    mounted(){
        this.$store.state.user.permissions.forEach(element => {
            this.perms.push(element.name)
        });
        this.getPacks()
    },
    computed: {
        filteredPacks() {
            const search = this.tableSearch.trim().toLowerCase()
            const packs = Array.isArray(this.packs) ? this.packs : []
            return search ? packs.filter(pack => [pack.libelle, pack.amount].some(value => String(value || '').toLowerCase().includes(search))) : packs
        },
    },
    methods:{
        getPacks(){
            let app = this
            axios.get('packs')
            .then(function (reponse){
                console.log(reponse);
                if (reponse.data.status == true) {
                    app.packs = reponse.data.data
                }
            })
            .then(function (error){
                console.log(error);
            })
        },
        destroy(id) {
            Swal.fire({
                title: 'Do you want to delete this pack ?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, deleted!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete('packs/'+id)
                    .then(response => {
                        console.log(response.data)
                        this.isLoading =  false
                        Swal.fire(
                            'Deleted!',
                            'The pack was deleted.',
                            'success'
                        )
                        location.reload()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                    
                }
            })
            
        },
    }
}
</script>